import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { displayCreationModal } from 'saas/sites/modals';
import { connect } from 'react-redux';
import { addSite, selectSite, unselectSite } from '../actions/sites';
import { getSites } from '../reducers/sites';
import { getSiteId, getErrors } from '../reducers/form';
import Dropdown from 'common/components/Dropdown';
import { Button, Form, Icon } from 'semantic-ui-react';

class SiteSelector extends Component {
  constructor(props) {
    super(props);

    this._onAddSite = this._onAddSite.bind(this);
  }

  _onAddSite(evt) {
    evt.stopPropagation();
    evt.preventDefault();

    const onSaved = this.props.onAdded;

    // Displaying site modal
    displayCreationModal(this.props.customerId, onSaved);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  render() {
    const { sites, siteId, onSelected, readOnly } = this.props;

    const renderDefault = () => (
      <div className="default text">Choisissez un site</div>
    );

    const renderSite = site => (
      <div key={site.id} data-value={site.id} className="item">
        {site.name} - {site.address} {site.zipCode} {site.city}
      </div>
    );

    const isSiteSelected = s => siteId.toString() === s.id.toString();

    const filteredSites = sites.filter(
      s => s.deleted !== true || isSiteSelected(s)
    );

    const onSiteChange = id => {
      onSelected(filteredSites.find(s => s.id.toString() === id));
    };

    return (
      <Form.Field>
        <label>Site</label>
        <Form.Group>
          <Form.Field width={13}>
            <Dropdown
              name="ref_site_id"
              value={siteId}
              items={sites}
              renderDefault={renderDefault}
              renderItem={renderSite}
              onChange={onSiteChange}
              disabled={readOnly}
            />
          </Form.Field>
          <Form.Field>
            <Button
              icon
              labelPosition="left"
              onClick={this._onAddSite}
              disabled={readOnly}
            >
              <Icon name="add" />
              Créer
            </Button>
          </Form.Field>
        </Form.Group>
      </Form.Field>
    );
  }
}

SiteSelector.propTypes = {
  sites: PropTypes.array.isRequired,
  siteId: PropTypes.number, //TODO set required
  onAdded: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onUnselected: PropTypes.func.isRequired,
  errors: PropTypes.array.isRequired,
  customerId: PropTypes.number.isRequired,
};

const mapStateToProps = state => ({
  sites: getSites(state),
  siteId: getSiteId(state),
  errors: getErrors(state),
});

const mapDispatchToProps = dispatch => ({
  onSelected: site => dispatch(selectSite(site)),
  onUnselected: site => dispatch(unselectSite(site)),
  onAdded: site => dispatch(addSite(site)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SiteSelector);



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/components/SiteSelector.js